// The public types of the import mapping package (CHT-707). The package has no dependency: it is pure
// code that runs in the API (the authority) and in the admin (the same function for the preview).
// The code tuples repeat the domain's and the schemas' tuples; `packages/application` has a parity test
// that fails when one differs.
/** The item types of the catalog. Repeated from the domain's `catalogItemTypes`. */
export const importItemTypes = ["DINING", "VILLA", "EVENT", "EXPERIENCE", "SERVICE"];
/** `common` fields apply to every item type; the others belong to one type. */
export const importTargetGroups = [
    "common",
    "event",
    "dining",
    "villa",
    "experience",
    "service",
];
/** What staff decided for one source column. `UNMAPPED` means "not decided yet". */
export const importColumnDecisionKinds = ["MAPPED", "IGNORED", "UNMAPPED"];
/**
 * How sure a suggestion is. HIGH: the header equals a target key, a built-in alias or a learned alias.
 * MEDIUM: a similar header. It is shown, never applied. NONE: no suggestion.
 */
export const importSuggestionConfidences = ["HIGH", "MEDIUM", "NONE"];
export const importSuggestionSources = ["BUILT_IN", "LEARNED", "SIMILARITY", "NONE"];
/** `SUGGESTION`: the mapped target is the HIGH suggestion. `STAFF`: staff chose it. */
export const importDecisionOrigins = ["SUGGESTION", "STAFF"];
export const importMappingIssueCodes = [
    "COLUMN_OUT_OF_RANGE",
    "COLUMN_DUPLICATE",
    "COLUMN_MISSING",
    "DECISION_SHAPE",
    "TARGET_UNKNOWN",
    "TARGET_DUPLICATE",
    "COLUMN_UNDECIDED",
    "NAME_NOT_MAPPED",
    "ITEM_TYPE_MISSING",
    "ITEM_TYPE_CONFLICT",
];
export const IMPORT_PROPOSAL_SCHEMA_VERSION = 1;
/** The version of the built-in alias set. A change to the set raises it. */
export const BUILTIN_ALIAS_VERSION = 2;
/** A MEDIUM suggestion needs a similarity of at least this much (TableFlow's measure, stricter cut-off). */
export const IMPORT_SIMILARITY_THRESHOLD = 0.85;
